import React from 'react'

const agentProfile = () => {
  return (
    <div>agentProfile</div>
  )
}

export default agentProfile